// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');



/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/es7.weak-set.from.js
 **/